import { useState } from 'react';
import {
  Modules,
  sellerLearningCenterApiClient,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { CODE_SUCCESS } from '@features/constants/network';

export const useCarouselModuleModel = () => {
  const [moduleArr, setModuleArr] = useState<Array<Modules[]>>([]);

  const fetchModuleData = async () => {
    const res = await sellerLearningCenterApiClient.GetModules({});
    if (res.code === CODE_SUCCESS && res.data) {
      // learning_id equal to 0 means dirty data, need to be filtered
      const modules = res.data?.modules?.filter(module =>
        module?.learning_info?.some(item => Number(item.learning_id) !== 0),
      );
      const modulesLen = modules?.length ?? 0;
      const tmpArr: Array<Modules[]> = [];
      let i = 0;
      while (i < modulesLen) {
        if (modulesLen % 2 === 1 && i + 2 > modulesLen && i !== 0) {
          i--;
        }
        tmpArr.push([...modules!.slice(i, i + 2)]);
        i += 2;
      }
      setModuleArr(tmpArr);
    }
  };

  const states = {
    moduleArr,
  };
  const actions = {
    fetchModuleData,
  };
  return {
    ...states,
    ...actions,
  };
};
